"use strict"

import _ from "lodash"
import angular from "angular"
import moment from "moment"
import { kStandardLabels } from "../../../../../components/counter-label"

const kDateFormat = "YYYY-MM-DD"

angular
  .module("uCountitUiApp")

  .controller("FreitagExportConfigCtrl", function ($scope, ExportConfigSrv, ApiSrv, Locale) {
    $scope.buildHours = {
      options: _.range(1, 24).map((h) => ({
        value: h,
        name: `${h < 10 ? "0" : ""}${h}:00`,
      })),
    }
    $scope.buildHours.selected = $scope.buildHours.options[1]

    $scope.$watch("buildHours.selected", function (hour) {
      if (hour && $scope.config) {
        $scope.config.buildHour = hour.value
      }
    })

    $scope.storeOptions = []

    $scope.targetStoreSelections = []

    const initializeTargetStores = async function (selectedItem, freitagConfig) {
      const stores = await ApiSrv.getAllStore({ companyId: selectedItem._id, isCache: true })

      const storeOptions = stores.map((store) => ({
        value: store._id,
        name: store.name,
        labels: store.labels,
      }))

      const targetStoreSelections = []

      for (const targetStore of freitagConfig.targetStores || []) {
        const store = _.find(storeOptions, { value: targetStore.storeId })
        const labels = store ? getLabels(store) : []
        targetStoreSelections.push({
          selectedStore: store,
          labelOptions: labels,
          selectedLabel: _.find(labels, { value: targetStore.labelId }),
        })
      }

      $scope.storeOptions = storeOptions
      $scope.targetStoreSelections = targetStoreSelections
    }

    $scope.selectStore = function (idx, item) {
      $scope.config.targetStores[idx].storeId = item.value
      $scope.config.targetStores[idx].labelId = null

      $scope.targetStoreSelections[idx].labelOptions = getLabels(item)
      $scope.targetStoreSelections[idx].selectedLabel = null
    }

    $scope.selectLabel = function (idx, item) {
      $scope.config.targetStores[idx].labelId = item.value
    }

    $scope.addTargetStore = function () {
      if (!$scope.config.targetStores) {
        $scope.config.targetStores = []
      }

      $scope.targetStoreSelections.push({
        selectedStore: null,
        labelOptions: [],
        selectedLabel: null,
      })
      $scope.config.targetStores.push({
        storeId: null,
        labelId: null,
        csvFilename: "",
      })
    }

    $scope.removeTargetStore = function (idx) {
      $scope.targetStoreSelections.splice(idx, 1)
      $scope.config.targetStores.splice(idx, 1)
    }

    const getLabels = function (storeInfo) {
      const standardLabelOptions = kStandardLabels.map((label) => ({
        name: Locale.string(label.i18nKey),
        value: label._id,
        group: "",
      }))
      const customLabelOptions = storeInfo
        ? storeInfo.labels.map((label) => ({
            name: label.name,
            value: label._id,
            group: " ",
          }))
        : []

      const labelOptions = standardLabelOptions.concat(customLabelOptions)

      return labelOptions
    }

    $scope.timezone = ""
    $scope.offset = "+00:00"

    const setLastTimeZone = async function (item) {
      if (!item) {
        $scope.timezone = ""
        $scope.offset = "+00:00"
        return
      }

      const allStores = await ApiSrv.getAllStore({ companyId: item._id, isCache: true })

      const stores = allStores
        .filter((store) => store.orgType === "store")
        .map(function (store) {
          const offset = moment.tz(store.timezone != null ? store.timezone : "UTC").utcOffset()
          store.offset = offset
          return store
        })

      const store = _.minBy(stores, "offset")

      $scope.timezone = store?.timezone || ""
      $scope.offset = store ? moment.tz(store.timezone).format("Z") : "+00:00"
    }

    $scope.$watch("form", async function (form) {
      if (!$scope.selectedItem) {
        return
      }

      const freitagConfig = form.freitag

      await initializeTargetStores($scope.selectedItem, freitagConfig)
      setLastTimeZone($scope.selectedItem)
      setDateTimePicker()

      const buildHourSelected = _.find($scope.buildHours.options, {
        value: freitagConfig.buildHour,
      })
      $scope.buildHours.selected = buildHourSelected || $scope.buildHours.options[1]

      if (freitagConfig.sftpConfig?.hasPassword) {
        freitagConfig.sftpConfig.passwordChange = false
      } else {
        freitagConfig.sftpConfig.passwordChange = true
      }

      $scope.config = freitagConfig
    })

    $scope.connectionTest = {
      status: "idle", // idle, testing, success, error
      message: "",
    }

    $scope.testConnection = async function () {
      $scope.connectionTest.status = "testing"
      try {
        const result = await ExportConfigSrv.ConnectionTest.test(
          { id: $scope.selectedItem._id, service: "freitag-export" },
          $scope.form
        ).$promise
        if (result && result.success) {
          $scope.connectionTest.status = "success"
        } else {
          $scope.connectionTest.status = "error"
          $scope.connectionTest.message = result.message
        }
      } catch (e) {
        $scope.connectionTest.status = "error"
        $scope.connectionTest.message = "Connection failed"
      }
    }

    const setDateTimePicker = function () {
      const options = {
        locale: { format: kDateFormat, applyLabel: "Download" },
        maxDate: moment().endOf("day"),
        autoUpdateInput: false,
        maxSpan: { months: 1 },
      }

      const element = $('#export-config input[name="freitag-log-button"]')

      element.daterangepicker2(options)

      element.on("apply.daterangepicker", async (_ev, picker) => {
        const logs = []
        for (let m = moment(picker.startDate); m.isBefore(picker.endDate); m.add(1, "days")) {
          logs.push(
            ...(await ExportConfigSrv.Log.get({
              id: $scope.selectedItem._id,
              service: "freitag-export",
              date: m.toISOString(),
            }).$promise)
          )
        }

        const logString = logs
          .map((log) => `${log.createdAt} ${log.level.toUpperCase()} ${log.message}`)
          .join("\n")

        const blob = new Blob([logString], { type: "text/plain;charset=utf-8" })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url
        a.download = `export_${$scope.selectedItem.name}_build_log(${picker.startDate.format(
          kDateFormat
        )}~${picker.endDate.format(kDateFormat)}).log`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      })
    }
  })
